import { Prop } from '@typegoose/typegoose'

export class OAuth {
  @Prop({ type: String })
  accessToken: string

  @Prop({ type: String })
  provider: string

  @Prop({ type: String })
  refreshToken: string
}
